import { Card, Typography } from "antd"
import VSpace from "../../common/VSpace"
import { InvoiceSendOptions } from "../../../domain/invoicing/invoicingApi"
import SwitchWithDescription from "../../common/SwitchWithDescription"
import { toggleRequireAuthorizePaymentOnFile, toggleShowAuthorizePaymentOnFile } from "./paymentMethodOnFileModel"

type Props = {
  options: InvoiceSendOptions
  onUpdate: (updated: InvoiceSendOptions) => void
}

const PaymentMethodOnFileCard = ({ options, onUpdate }: Props) => {
  return <Card
    title={<div style={{ margin: "16px 0" }}>
    Settings for "Authorize My Payment Method on File"
    <br/>
    <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>
      Set the behavior for how customers see and use the payment authorization option during checkout.
    </Typography.Text>
  </div>}
  >
    <VSpace size="large">
      <SwitchWithDescription
        checked={options.showAuthorizePaymentOnFile}
        label="Request Payment Method on File"
        description="Display the option for customers to authorize saving their payment method for future use."
        onClick={() => onUpdate(toggleShowAuthorizePaymentOnFile(options))}
      />
      {options.showAuthorizePaymentOnFile && <div style={{marginLeft: 50, borderLeft: '1px solid #00000026', paddingLeft: 12}}>
        <SwitchWithDescription
          checked={options.requireAuthorizePaymentOnFile}
          label="Require Payment Method on File"
          description="Make it required for customers to authorize saving their payment method for future use."
          onClick={() => onUpdate(toggleRequireAuthorizePaymentOnFile(options))}
        />
      </div>}
    </VSpace>
  </Card>
}

export default PaymentMethodOnFileCard
